import React from 'react';
import { Field } from 'redux-form';
import styled from 'styled-components';
import { Spinner } from '@sparebankenvest/splash-ui';
import { Check as CheckRaw, InfoCircle as InfoCircleRaw } from '@sparebankenvest/icons';
import { Input } from './Forms';
import { normalizePostnummer } from '../format.util';
import i18n from '../i18n';

const Wrapper = styled.div`
  display: flex;
  align-items: flex-end;
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const capitalizeFirstLetter = name => (
  `${name.substr(0, 1)}${name.substr(1).toLowerCase()}`
);

const Check = styled(CheckRaw)`
  fill: #5B8601;
  width: 24px;
  height: 24px;
`;

const InfoCircle = styled(InfoCircleRaw)`
  fill: #E2958B;
  width: 24px;
  height: 24px;
`;

const WrapperPostMessage = styled.div`
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-items: center;
  height: 70px;
  color: #444;
  svg {
    margin-right: 8px;
    margin-left: 20px;
  }
  @media (max-width: 600px) {
    height: auto;
    margin-bottom: 10px;
    svg {
      margin-left: 0;
      width: 18px;
      height: 18px;
    }
    span {
      font-size: 14px;
      font-weight: 400;
    }
  }
`;

const PostNumberMessage = ({ beregnetVerdi, postnummer, loading }) => {
  if (loading) {
    return null;
  }
  if (beregnetVerdi.areacodeInfo && !beregnetVerdi.isInnenforSPV) {
    return (
      <WrapperPostMessage>
        <InfoCircle />
        <span>{i18n(i => i.UTENFOR_VESTLAND_OG_ROGALAND_TOOLTIP)}</span>
      </WrapperPostMessage>
    );
  }
  if (!beregnetVerdi.areacodeInfo) {
    return (
      <WrapperPostMessage>
        <InfoCircle />
        <span>{i18n(i => i.FINNER_IKKE_POSTNUMMER, { postnummer })}</span>
      </WrapperPostMessage>
    )
  }
  if (beregnetVerdi.areacodeInfo[2] !== 'Grønn') {
    return (
      <WrapperPostMessage>
        <InfoCircle />
        <span>
          {i18n(i => i.UTENFOR_ALLFARVEI)}
        </span>
      </WrapperPostMessage>
    )
  }
  return (
    <WrapperPostMessage>
      <Check />
      <span>
        {i18n(i => i.POSTSTED, {
          poststed: capitalizeFirstLetter(beregnetVerdi.areacodeInfo[1]),
        })}
      </span>
    </WrapperPostMessage>
  );
};

const Postnummer = ({ beregnetVerdi, postnummer, loading }) => {
  return (
    <Wrapper>
      <Field
        name="postnummer"
        label={i18n(i => i.POSTNUMMER_LABEL)}
        component={Input}
        format={normalizePostnummer}
        transformableLabel={false}
        type="tel"
        rightInlineElement={() => (loading && <Spinner />)}
      />
      <PostNumberMessage
        beregnetVerdi={beregnetVerdi}
        loading={loading || postnummer.length !== 4 || !beregnetVerdi}
        postnummer={postnummer}
      />
    </Wrapper>
  );
};

export default Postnummer;